import { Box, Button, Stack, type SxProps, type Theme, Typography } from '@mui/material'

const styles: Record<string, SxProps<Theme>> = {
  container: {
    width: '100%',
    bgcolor: 'secondary.main',
    borderRadius: '12px',
    overflow: 'hidden'
  },
  box: {
    bgcolor: 'common.white',
    p: '20px',
    border: '5px solid',
    borderColor: 'secondary.main',
    borderTop: 0,
    borderBottomLeftRadius: '12px',
    borderBottomRightRadius: '12px'
  },
  button: {
    width: 'fit-content',
    height: 'fit-content',
    padding: '9.5px 20px',
    bgcolor: 'secondary.main',
    color: 'common.white',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: '600',
    gap: '36px',
    mt: 'auto',
    '&:hover': {
      bgcolor: 'secondary.dark'
    }
  }
}

interface ProgressReportCardProps {
  title: string
  date: string
  description: string
  buttonText?: string
  onButtonClick: () => void
  testId?: string
  comingSoon?: boolean
}

export const ProgressReportCard = ({
  title,
  date,
  description,
  buttonText = 'Preview Report',
  onButtonClick,
  testId,
  comingSoon = false
}: ProgressReportCardProps): JSX.Element => {
  return (
    <Stack data-testid={testId} sx={styles.container}>
      <Box sx={{ padding: '16px', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'baseline' }}>
        <Typography variant='h3' color='common.white'>{title}</Typography>
        <Box sx={{ display: 'flex', alignItems: 'baseline', gap: '4px', color: 'common.white' }}>
          <Typography variant='h3' color='common.white'>{comingSoon ? 'Coming Soon' : 'Available'}</Typography>
          {!comingSoon && <Typography variant='h4' color='common.white'>: [{date}]</Typography>}
        </Box>
      </Box>
      <Stack gap='20px' sx={styles.box}>
        <Typography variant='body1' fontWeight='600'>
          {description}
        </Typography>

        <Stack direction='row' gap='20px'>
          <Button sx={styles.button} variant='contained' onClick={onButtonClick} disabled={comingSoon}>
            {buttonText}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  )
}
